import type { CardChartType, MetricNodeType } from '../api/types';

/** Chart a card shows when it has no ``chart_type`` of its own. */
const DEFAULT_CHART_TYPE: Record<MetricNodeType, CardChartType> = {
  data_card: 'line',
  group_card: 'bar',
  status_card: 'bar'
};

/** Chart types a card of this type can show. Status cards are yes/no, so no line. */
export const chartTypesFor = (nodeType: MetricNodeType): CardChartType[] =>
  nodeType === 'status_card' ? ['bar', 'dial'] : ['line', 'bar', 'dial'];

export const resolveChartType = (
  chartType: CardChartType | null | undefined,
  nodeType: MetricNodeType
): CardChartType =>
  chartType && chartTypesFor(nodeType).includes(chartType) ? chartType : DEFAULT_CHART_TYPE[nodeType];
